import type { JobType } from "@repo/app-types/entities/jobType";
import {
  getTagsInvalidatedByUpdate,
  getTagsProvidedByList,
  TagType,
} from "../helpers/tags.js";
import { api } from "../redux.js";

export const jobTypeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Job Type endpoints
    allJobTypes: builder.query<JobType[], void>({
      query: () => "/job-types",
      providesTags: (result) => getTagsProvidedByList(TagType.JobType, result),
    }),
    updateJobType: builder.mutation<
      JobType,
      Pick<JobType, "id"> &
        Partial<
          Pick<
            JobType,
            | "name"
            | "questions"
            | "job_description"
            | "prompt_context"
            | "settings"
          >
        >
    >({
      query: (values) => ({
        method: "PATCH",
        url: `/job-types/${encodeURIComponent(values.id)}`,
        body: values,
      }),
      invalidatesTags: (result, error, { id }) =>
        getTagsInvalidatedByUpdate(TagType.JobType, id),
    }),
  }),
});

export const { useAllJobTypesQuery, useUpdateJobTypeMutation } = jobTypeApi;
